// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1-O6J","rootSmall":"AddTileButton_rootSmall__3TJ3e"};